/* eslint-disabled */

export default class TypeAvenantExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
